import { createAction } from '@reduxjs/toolkit';
import { INITIALIZE_STORE_AVATARS, SET_SELECTED_AVATAR } from './types';

// eslint-disable-next-line import/prefer-default-export
export const initializeStoreAvatars = createAction(INITIALIZE_STORE_AVATARS);
export const setSelectedAvatar = createAction(SET_SELECTED_AVATAR);
